module.exports = __webpack_public_path__ + "static/media/wheel-dontoi.9b339e82.png";